export default __webpack_public_path__ + "static/media/Plus_round_line.3cdf1542.svg";